// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2GKPF","rootSmall":"AddTileButton_rootSmall__2UXg2"};